import { render } from "./EdgePersonSelect.vue?vue&type=template&id=314f330b&scoped=true"
import script from "./EdgePersonSelect.vue?vue&type=script&lang=js"
export * from "./EdgePersonSelect.vue?vue&type=script&lang=js"

import "./EdgePersonSelect.vue?vue&type=style&index=0&id=314f330b&lang=less"
import "./EdgePersonSelect.vue?vue&type=style&index=1&id=314f330b&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314f330b"]])

export default __exports__